import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [
  {
    path: '/auth',
    name: 'auth',
    redirect: { name: 'auth.login' },
    component: () => import('@/views/auth/default.vue'),
    children: [
      {
        path: 'login',
        name: 'auth.login',
        component: () => import('@/views/auth/login.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'layout',
    meta: { title: 'FAWN CRM' },
    redirect: { name: 'dashboard' },
    component: () => import('@/views/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        meta: { title: 'Dashboard' },
        component: () => import('@/views/pages/dashboard.vue')
      },

      {
        path: 'users',
        name: 'users',
        meta: { title: 'Users' },
        component: () => import('@/views/users/index.vue')
      },

      {
        path: 'stores',
        name: 'stores',
        meta: { title: 'Stores' },
        component: () => import('@/views/stores/index.vue')
      },
      {
        path: 'stores/:id/renewal',
        name: 'stores.renewal',
        meta: { title: '门店续费' },
        component: () => import('@/views/stores/renewal.vue')
      },
      {
        path: 'withdrawals',
        name: 'withdrawals',
        meta: { title: 'Withdrawals' },
        component: () => import('@/views/withdrawals/index.vue')
      },
      {
        path: 'drafts',
        name: 'drafts',
        meta: { title: 'Drafts' },
        component: () => import('@/views/drafts/index.vue')
      },
      {
        path: 'merchant_orders',
        name: 'merchant_orders',
        meta: { title: 'Merchant Orders' },
        component: () => import('@/views/merchant_orders/index.vue')
      },
      {
        path: 'dramas',
        name: 'dramas',
        meta: { title: 'Dramas' },
        component: () => import('@/views/dramas/index.vue')
      },
      {
        path: 'mini_programs',
        name: 'mini_programs',
        meta: { title: 'MiniPrograms' },
        component: () => import('@/views/mini_programs/index.vue')
      },
      {
        path: 'drama_completions',
        name: 'drama_completions',
        meta: { title: 'Drama Completions' },
        component: () => import('@/views/drama_completions/index.vue')
      },
      {
        path: 'drama_completions/:id/detail',
        name: 'drama_completions.detail',
        meta: { title: 'Drama Completion Detail' },
        component: () => import('@/views/drama_completions/detail.vue')
      },
      {
        path: 'original_dramas',
        name: 'original_dramas',
        meta: { title: 'Original Dramas' },
        component: () => import('@/views/original_dramas/index.vue')
      },
      {
        path: 'original_dramas/create',
        name: 'original_dramas.create',
        meta: { title: 'Create Original Dramas' },
        component: () => import('@/views/original_dramas/create.vue')
      },
      {
        path: 'original_dramas/:id/edit',
        name: 'original_dramas.edit',
        meta: { title: 'Edit Original Dramas' },
        component: () => import('@/views/original_dramas/edit.vue')
      },

      {
        path: 'asks',
        name: 'asks',
        meta: { title: 'Faqs' },
        component: () => import('@/views/asks/index.vue')
      },
      {
        path: 'asks/create',
        name: 'asks.create',
        meta: { title: 'Create Faq' },
        component: () => import('@/views/asks/create.vue')
      },
      {
        path: 'asks/:id/edit',
        name: 'asks.edit',
        meta: { title: 'Edit Faq' },
        component: () => import('@/views/asks/edit.vue')
      },

      {
        path: 'ws_accounts',
        name: 'ws_accounts',
        meta: { title: '小鹿助手' },
        component: () => import('@/views/ws_accounts/index.vue')
      },
      {
        path: 'mini_program_wechat_pays',
        name: 'mini_program_wechat_pays',
        meta: { title: '微信支付' },
        component: () => import('@/views/mini_program_wechat_pays/index.vue')
      },
      {
        path: 'merchant_mini_program_tasks',
        name: 'merchant_mini_program_tasks',
        meta: { title: '小程序申请' },
        component: () => import('@/views/merchant_mini_program_tasks/index.vue')
      },

      {
        path: 'notices',
        name: 'notices',
        meta: { title: 'Notices' },
        component: () => import('@/views/notices/index.vue')
      },
      {
        path: 'notices/create',
        name: 'notices.create',
        meta: { title: 'Create Notice' },
        component: () => import('@/views/notices/create.vue')
      },
      {
        path: 'notices/:id/edit',
        name: 'notices.edit',
        meta: { title: 'Edit Notice' },
        component: () => import('@/views/notices/edit.vue')
      },

      {
        path: 'upgrades',
        name: 'upgrades',
        meta: { title: 'Upgrades' },
        component: () => import('@/views/upgrades/index.vue')
      },
      {
        path: 'upgrades/create',
        name: 'upgrades.create',
        meta: { title: 'Create Upgrade' },
        component: () => import('@/views/upgrades/create.vue')
      },
      {
        path: 'upgrades/:id/edit',
        name: 'upgrades.edit',
        meta: { title: 'Edit Upgrade' },
        component: () => import('@/views/upgrades/edit.vue')
      }
    ]
  }
]

export default routes
